import { useEffect } from 'react';

// react-router-dom components
import { useLocation } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// Argon Dashboard 2 MUI components
import ArgonBox from 'components/ArgonBox';

// Argon Dashboard 2 MUI context
import { useArgonController, setLayout } from 'context';
import { Card, Grid } from '@mui/material';

function PageLayout({ background, children, image }) {
  const [controller, dispatch] = useArgonController();
  const { darkMode } = controller;

  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'page');
  }, [pathname]);

  return (
    <ArgonBox
      width="100vw"
      height="100vh" // Full viewport height
      minHeight="100vh"
      bgColor={darkMode ? 'transparent' : background}
      sx={{ overflowX: 'hidden' }}
    >
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }} // Ensure Grid takes full height
      >
        <Card>
          <Grid item xs={12}>
            {children}
          </Grid>
        </Card>
      </Grid>
    </ArgonBox>
  );
}

// Setting default values for the props for PageLayout
PageLayout.defaultProps = {
  background: 'default',
};

// Typechecking props for the PageLayout
PageLayout.propTypes = {
  background: PropTypes.oneOf(['white', 'light', 'default']),
  children: PropTypes.node.isRequired,
};

export default PageLayout;
